"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _WireObject2 = _interopRequireDefault(require("../WireObject"));

var _CreativeDocumentTransform = _interopRequireDefault(require("./CreativeDocumentTransform"));

var _creative = require("../../constants/creative");

var _convertMapToObject = _interopRequireDefault(require("../../utils/object/convertMapToObject"));

var _convertObjectToMap = _interopRequireDefault(require("../../utils/object/convertObjectToMap"));

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

var _removeUnusedKeys = _interopRequireDefault(require("../../utils/object/removeUnusedKeys"));

var _toJSON2 = _interopRequireDefault(require("../../utils/object/toJSON"));

var _getGuid = _interopRequireDefault(require("../../utils/guid/getGuid"));

var _deepCopy = _interopRequireDefault(require("../../utils/object/deepCopy"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CreativeDocumentElement = /*#__PURE__*/function (_WireObject) {
  (0, _inherits2["default"])(CreativeDocumentElement, _WireObject);

  var _super = _createSuper(CreativeDocumentElement);

  /**
   * String defining the way in which this element will blend with the elements before it. From AlphaBlendModes
   */

  /**
   * String ID indicating which content item is associated with this element
   */

  /**
   * String description of this layer, optional
   */

  /**
   * Object containing a temporary transform object used while editing in real time (Drag/Drop). Used with isEditingTransform
   */

  /**
   * String representing the ID of this element
   */

  /**
   * The last frame (inclusive, root-relative) that this element is visible in the creative
   */

  /**
   * The first frame (inclusive, root-relative) that this element is visible in the creative
   */

  /**
   * The ID of an element of content type ELEMENT_GROUP or ELEMENT_EFFECT_GROUP that is the parent of this element
   */

  /**
   * If in an ELEMENT_EFFECT_GROUP (contentType) indicates which role this element has from GROUP_ROLES
   */

  /**
   * Boolean indicating that the element is currently being transformed by the user. Used with editedTransform
   */

  /**
   * Boolean indicating that this element has been transformed by the user manually
   */

  /**
   * Object containing locked properties like rotate/scale/translate with values true/false. Empty should be treated as false
   * TODO make a Model
   */

  /**
   * Object containing metadata about this element. Values currently include items like excludedFromTemplate, bounds, fitMode
   * TODO make a Model
   */

  /**
   * String name of this element, can default to contentType
   */

  /**
   * String indicating the ID of the content object of type ELEMENT_GROUP which is this elements parent
   */

  /**
   * Boolean indicating that this element can be directly selected by a user
   */

  /**
   * Map of transforms keyed by keyframe number
   * TODO make Models
   */

  /**
   * @param {String} contentId - required contentId for element (for now)
   * @param {String|null} elementId - ID of the element, if not supplied a new one will be generated.
   */
  function CreativeDocumentElement(contentId) {
    var _this;

    var elementId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, _classCallCheck2["default"])(this, CreativeDocumentElement);

    if ((0, _isEmptyString["default"])(contentId)) {
      throw new Error('Cannot create CreativeDocumentElement without content ID');
    }

    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_alphaCompositeRule", _creative.DEFAULT_ALPHA_BLEND_MODE);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_contentId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_description", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_editedTransform", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_elementId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_frameEnd", _creative.MAX_FRAME_END);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_frameStart", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_groupId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_groupRole", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isEditingTransform", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isTransformedByUser", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_locked", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_meta", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_name", 'Layer');
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parentContentId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_selectable", true);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_transforms", void 0);
    _this._contentId = contentId;
    _this._elementId = (0, _isEmptyString["default"])(elementId) ? CreativeDocumentElement.getId() : elementId;
    _this._transforms = new Map();

    _this._transforms.set(_creative.DEFAULT_KEYFRAME_NUMBER, new _CreativeDocumentTransform["default"]());

    return _this;
  }

  (0, _createClass2["default"])(CreativeDocumentElement, [{
    key: "copy",
    value: function copy() {
      var json = this.toJSON();
      return CreativeDocumentElement.fromJSON(json);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var elementObj = {
        alphaCompositeRule: this.alphaCompositeRule,
        contentId: this.contentId,
        description: this.description,
        editedTransform: this.editedTransform,
        elementId: this.elementId,
        frameEnd: this.frameEnd,
        frameStart: this.frameStart,
        groupId: this.groupId,
        groupRole: this.groupRole,
        isEditingTransform: this.isEditingTransform,
        isTransformedByUser: this.isTransformedByUser,
        locked: this.locked,
        meta: this.meta,
        name: this.name,
        parentContentId: this.parentContentId,
        selectable: this.selectable,
        transforms: (0, _convertMapToObject["default"])(this.transforms, _toJSON2["default"])
      };
      return (0, _removeUnusedKeys["default"])(elementObj);
    }
  }, {
    key: "alphaCompositeRule",
    get: function get() {
      return this._alphaCompositeRule;
    },
    set: function set(value) {
      this._alphaCompositeRule = value;
    }
  }, {
    key: "contentId",
    get: function get() {
      return this._contentId;
    },
    set: function set(value) {
      this._contentId = value;
    }
  }, {
    key: "description",
    get: function get() {
      return this._description;
    },
    set: function set(value) {
      this._description = value;
    }
  }, {
    key: "editedTransform",
    get: function get() {
      return this._editedTransform;
    },
    set: function set(value) {
      this._editedTransform = value;
    }
  }, {
    key: "elementId",
    get: function get() {
      return this._elementId;
    },
    set: function set(value) {
      this._elementId = value;
    }
  }, {
    key: "frameEnd",
    get: function get() {
      return this._frameEnd;
    },
    set: function set(value) {
      this._frameEnd = value;
    }
  }, {
    key: "frameStart",
    get: function get() {
      return this._frameStart;
    },
    set: function set(value) {
      this._frameStart = value;
    }
  }, {
    key: "groupId",
    get: function get() {
      return this._groupId;
    },
    set: function set(value) {
      this._groupId = value;
    }
  }, {
    key: "groupRole",
    get: function get() {
      return this._groupRole;
    },
    set: function set(value) {
      this._groupRole = value;
    }
  }, {
    key: "isEditingTransform",
    get: function get() {
      return this._isEditingTransform;
    },
    set: function set(value) {
      this._isEditingTransform = value;
    }
  }, {
    key: "isTransformedByUser",
    get: function get() {
      return this._isTransformedByUser;
    },
    set: function set(value) {
      this._isTransformedByUser = value;
    }
  }, {
    key: "locked",
    get: function get() {
      return this._locked;
    },
    set: function set(value) {
      this._locked = value;
    }
  }, {
    key: "meta",
    get: function get() {
      return this._meta;
    },
    set: function set(value) {
      this._meta = value;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    },
    set: function set(value) {
      this._name = value;
    }
  }, {
    key: "parentContentId",
    get: function get() {
      return this._parentContentId;
    },
    set: function set(value) {
      this._parentContentId = value;
    }
  }, {
    key: "selectable",
    get: function get() {
      return this._selectable;
    },
    set: function set(value) {
      this._selectable = value;
    }
  }, {
    key: "transforms",
    get: function get() {
      return this._transforms;
    },
    set: function set(value) {
      this._transforms = value;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inElement) {
      var alphaCompositeRule = inElement.alphaCompositeRule,
          contentId = inElement.contentId,
          description = inElement.description,
          editedTransform = inElement.editedTransform,
          elementId = inElement.elementId,
          frameEnd = inElement.frameEnd,
          frameStart = inElement.frameStart,
          groupId = inElement.groupId,
          groupRole = inElement.groupRole,
          isEditingTransform = inElement.isEditingTransform,
          isTransformedByUser = inElement.isTransformedByUser,
          locked = inElement.locked,
          meta = inElement.meta,
          name = inElement.name,
          parentContentId = inElement.parentContentId,
          selectable = inElement.selectable,
          transforms = inElement.transforms;
      var creativeDocumentElement = new CreativeDocumentElement(contentId, elementId);
      creativeDocumentElement.alphaCompositeRule = alphaCompositeRule;
      creativeDocumentElement.description = description;
      creativeDocumentElement.editedTransform = (0, _deepCopy["default"])(editedTransform);
      creativeDocumentElement.frameEnd = frameEnd;
      creativeDocumentElement.frameStart = frameStart;
      creativeDocumentElement.groupId = groupId;
      creativeDocumentElement.groupRole = groupRole;
      creativeDocumentElement.isEditingTransform = isEditingTransform;
      creativeDocumentElement.isTransformedByUser = isTransformedByUser;
      creativeDocumentElement.locked = (0, _deepCopy["default"])(locked);
      creativeDocumentElement.meta = (0, _deepCopy["default"])(meta);
      creativeDocumentElement.name = name;
      creativeDocumentElement.parentContentId = parentContentId;
      creativeDocumentElement.selectable = selectable;
      creativeDocumentElement.transforms = (0, _convertObjectToMap["default"])(transforms, _CreativeDocumentTransform["default"].fromJSON);
      return creativeDocumentElement;
    }
  }, {
    key: "getId",
    value: function getId() {
      return "element-".concat((0, _getGuid["default"])());
    }
  }]);
  return CreativeDocumentElement;
}(_WireObject2["default"]);

exports["default"] = CreativeDocumentElement;